import { LegalModel, LegalState } from './legalModel';

export type LegalAction =
  | { type: 'FETCH_START' }
  | { type: 'FETCH_SUCCESS'; payload: LegalModel }
  | { type: 'FETCH_ERROR'; payload: string }
  | { type: 'SET_PRODUCT_NAME'; payload: string }
  | { type: 'RESET' };

export const initialLegalState: LegalState = {
  model: LegalModel.initial(),
  loading: false,
  error: null,
  productName: ''
};

export const legalReducer = (
  state: LegalState,
  action: LegalAction
): LegalState => {
  switch (action.type) {
    case 'FETCH_START':
      return { ...state, loading: true, error: null };

    case 'FETCH_SUCCESS':
      return { ...state, model: action.payload, loading: false };

    case 'FETCH_ERROR':
      return { ...state, loading: false, error: action.payload };

    case 'SET_PRODUCT_NAME':
      return { ...state, productName: action.payload };

    case 'RESET':
      return initialLegalState;

    default:
      return state;
  }
};
